import { useContext, useEffect, useRef, useState } from 'react'

import { Context } from 'lib/context/probate-estate-request-status'
import useApiHelpers from 'lib/effects/api-helpers'

const useProbateEstateCollection = ({
  probateEstateId,
  collection,
  type,
}: {
  probateEstateId: number
  collection: string
  type: string
}) => {
  const { setErrors, setIsLoading } = useContext(Context)

  const {
    items,
    fetchItems,
    isFetching,
    fetchErrors,
    createItem,
    isCreating,
    createErrors,
    updateItem,
    isUpdating,
    updateErrors,
    deleteItem,
    isDeleting,
    deleteErrors,
  } = useApiHelpers({
    baseUrl: `/api/probate-estates/${probateEstateId}/${collection}`,
    type,
  })

  useEffect(() => {
    // avoids an unhandled promise rejection; fetchErrors already covers this
    fetchItems().catch(() => undefined)
  }, [fetchItems])

  const [isLoaded, setIsLoaded] = useState(false)
  const wasFetching = useRef(false)

  useEffect(() => {
    if (wasFetching.current && !isFetching) setIsLoaded(true)
    wasFetching.current = isFetching
  }, [isFetching])

  const errors = [
    ...fetchErrors,
    ...createErrors,
    ...updateErrors,
    ...deleteErrors,
  ]
  const isSaving = isCreating || isUpdating || isDeleting

  useEffect(() => {
    setErrors?.(errors)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setErrors, JSON.stringify(errors)])

  useEffect(() => {
    setIsLoading?.(isSaving)
  }, [setIsLoading, isSaving])

  return {
    items,
    isFetching,
    isLoaded,
    createItem,
    isCreating,
    updateItem,
    isUpdating,
    deleteItem,
    isDeleting,
  }
}

export default useProbateEstateCollection
